module.exports = __webpack_public_path__ + "img/3.dad0c68b.jpg";